import { render } from "./CaixaServico.vue?vue&type=template&id=e15a92b4&scoped=true&ts=true"
import script from "./CaixaServico.vue?vue&type=script&lang=ts"
export * from "./CaixaServico.vue?vue&type=script&lang=ts"

import "./CaixaServico.vue?vue&type=style&index=0&id=e15a92b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15a92b4"]])

export default __exports__